import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=3edcf092&scoped=true&"
import script from "./OptionItem.vue?vue&type=script&lang=ts&"
export * from "./OptionItem.vue?vue&type=script&lang=ts&"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=3edcf092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edcf092",
  null
  
)

export default component.exports